/* eslint-disable no-debugger */
import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    @Inject(LoginService) public auth: LoginService,
    public router: Router
  ) {}

  canActivate(): boolean {
    const authenticated = this.auth.isAuthenticated();
    console.log('[CanActivate]: ', authenticated);

    if (!authenticated) {
      console.warn('No está identificado');
      this.router.navigate(['']);
      return false;
    }

    return true;
  }
}
